import { fetchPosts } from 'wordpress/actions'
import contentToComponents from 'content/helpers'
import { loadOnMount, withRouteParams } from 'shared/hoc'

import { idSelector, tabContentSelector } from '../selectors'
import { renderNothing, branch } from 'recompose'

const ContentTab = ({ page }) => <div>{page.content.map((c, i) => contentToComponents({ ...c, key: i }))}</div>

export default compose(
    withRouteParams,
    connect(
        createStructuredSelector({
            id: idSelector,
            page: tabContentSelector,
        }),
        { fetchPosts }
    ),
    loadOnMount('fetchPosts', props => ['content', [props.pageId]]),
    branch(props => !props.page, renderNothing)
)(ContentTab)
